import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=6637189a&"
import script from "./ProjectView.vue?vue&type=script&lang=ts&"
export * from "./ProjectView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports